import React from "react";
import SignBillingInfo from "../components/SignBillingInfo";

const SignBillingInfoScreen = (props) => {
  return <SignBillingInfo {...props} />;
};
export default SignBillingInfoScreen;
